import type { FlagConfiguration } from '@atlassian/jira-flags'; // ignore-for-ENGHEALTH-17759
import messages from './messages.tsx';

export const REORDER_ITEM_FAIL_GENERIC_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.reorderErrorTitle,
	description: messages.reorderErrorDescription,
	messageId:
		'native-issue-table.services.rank-mutation.reorder-item-fail-generic-flag.error.update-item-parent-fail-generic-flag.error.reparent-mutation.update-item-parent-fail-generic-flag.error.flag.update-item-parent-fail-generic',
	messageType: 'transactional',
};

export const REORDER_ITEM_FAIL_400_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.reorderErrorTitle,
	description: messages.reorderIssue400ErrorDescription,
	messageId:
		'native-issue-table.services.rank-mutation.reorder-item-fail-400-flag.error.update-item-parent-fail-400-flag.error.reparent-mutation.update-item-parent-fail-400-flag.error.flag.update-issue-parent400error',
	messageType: 'transactional',
};

export const REORDER_ITEM_FAIL_400_FLAG_WITH_ISSUE_TERM: FlagConfiguration = {
	type: 'error',
	title: messages.reorderErrorTitleIssueTermRefresh,
	description: messages.reorderIssue400ErrorDescriptionIssueTermRefresh,
	messageId:
		'native-issue-table.services.rank-mutation.reorder-item-fail-400-flag-with-issue-term.error.update-item-parent-fail-400-flag-with-issue-term.error.reparent-mutation.update-item-parent-fail-400-flag-with-issue-term.error.flag.update-issue-parent400error-issue-term-refresh',
	messageType: 'transactional',
};

export const REORDER_ITEM_FAIL_404_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.reorderErrorTitle,
	description: messages.reorderIssue404ErrorDescription,
	messageId:
		'native-issue-table.services.rank-mutation.reorder-item-fail-404-flag.error.update-item-parent-fail-404-flag.error.reparent-mutation.update-item-parent-fail-404-flag.error.flag.update-issue-parent404error',
	messageType: 'transactional',
};

export const REORDER_ITEM_FAIL_404_FLAG_WITH_ISSUE_TERM: FlagConfiguration = {
	type: 'error',
	title: messages.reorderErrorTitleIssueTermRefresh,
	description: messages.reorderIssue404ErrorDescriptionIssueTermRefresh,
	messageId:
		'native-issue-table.services.rank-mutation.reorder-item-fail-404-flag-with-issue-term.error.update-item-parent-fail-404-flag-with-issue-term.error.reparent-mutation.update-item-parent-fail-404-flag-with-issue-term.error.flag.update-issue-parent404error-issue-term-refresh',
	messageType: 'transactional',
};

export const REORDER_ITEM_FAIL_409_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.reorderErrorTitle,
	description: messages.reorderIssue409ErrorDescription,
	messageId:
		'native-issue-table.services.rank-mutation.reorder-item-fail-409-flag.error.reorder-item-fail-404-flag.error.update-item-parent-fail-404-flag.error.reparent-mutation.update-item-parent-fail-404-flag.error.flag.update-issue-parent404error',
	messageType: 'transactional',
};

export const REORDER_ITEM_FAIL_409_FLAG_WITH_ISSUE_TERM: FlagConfiguration = {
	type: 'error',
	title: messages.reorderErrorTitleIssueTermRefresh,
	description: messages.reorderIssue409ErrorDescriptionIssueTermRefresh,
	messageId:
		'native-issue-table.services.rank-mutation.reorder-item-fail-409-flag-with-issue-term.error.reorder-item-fail-404-flag-with-issue-term.error.update-item-parent-fail-404-flag-with-issue-term.error.reparent-mutation.update-item-parent-fail-404-flag-with-issue-term.error.flag.update-issue-parent404error-issue-term-refresh',
	messageType: 'transactional',
};

export const RE_RANKING_EXPERIENCE = 'reRankIssue';
